import { formValueSelector } from 'redux-form'
import { FormAdapter } from 'core/utils/adapters'

export const ApiTokenFormFields = {
  name: 'name',
  endDate: 'end_date',
  permissions: 'permissions',
  enabled: 'enabled',
  apiTokens: 'apiTokens'
}

export const ApiTokenFormAdapter = new FormAdapter(ApiTokenFormFields, 'tokenForm')
export const apiTokenFormSelector = formValueSelector(ApiTokenFormAdapter.name)
